/**
 * The buy button: acid lime, an ink disc whose arrow flies out and back on hover (the look lives in `.buy`, packages/ui).
 * Without an `href` it leads to the program desk on the landing; a path starting with "/" goes through the router.
 */
import { ArrowUpRight } from "lucide-react";
import type { ReactNode } from "react";
import { Link } from "wouter";
import { useLandingT } from "../../i18n";

/** The label and the disc, for any element that carries the `buy` class (a link here, a button in the configurator). */
export function BuyBody({ children }: { children: ReactNode }) {
  return (
    <>
      <span>{children}</span>
      <span className="buy-ico" aria-hidden="true">
        <ArrowUpRight />
        <ArrowUpRight />
      </span>
    </>
  );
}

export function Buy({ href = "#programs", size, ink, label }: { href?: string; size?: "sm"; ink?: boolean; label?: string }) {
  const t = useLandingT();
  const cls = ["buy", size, ink && "ink"].filter(Boolean).join(" ");
  const body = <BuyBody>{label ?? t("buy")}</BuyBody>;
  return href.startsWith("/") ? (
    <Link href={href} className={cls}>
      {body}
    </Link>
  ) : (
    <a href={href} className={cls}>
      {body}
    </a>
  );
}
